import React from 'react';
import CmSkeleton from '../../../GeneralComponents/ui/CmSkeleton';
import RecordsHeader from './RecordsHeader';
import RecordsFilterRow from './RecordsFilterRow';
import RecordsRow from './RecordsRow';
import { navigateToCreate } from './RecordsToolbar';

export default function RecordsTable({
  columns, rows, loading,
  sortField, sortDir, onSort,
  showFilters, filters, hasActiveFilters, onFilterChange, onApplyFilters, onClearFilters,
  selectedIds, onSelect, onSelectAll,
  editingCell, savingCell, onStartEdit, onCancelEdit, onSaveEdit,
  formato, format_category, estados, users, procesos, positions, domain, custom_view_id,
  configuration_format, onSendEmails, onViewConfirmations, onRefresh,
  froalaConfig, showColumnOptions
}) {
  const allSelected = rows.length > 0 && selectedIds.length === rows.length;

  return (
    <div className="cm-dt-scroll">
      <table className="cm-dt-table">
        <thead>
          {loading && columns.length === 0 ? (
            <tr>
              <th className="cm-dt-actions" />
              <th className="cm-dt-check" />
              {Array.from({ length: 6 }).map((_, i) => (
                <th key={i}>
                  <div className="cm-skeleton-bar" style={{ width: `${50 + Math.random() * 30}%`, height: 12 }} />
                </th>
              ))}
            </tr>
          ) : (
            <RecordsHeader
              columns={columns}
              sortField={sortField}
              sortDir={sortDir}
              onSort={onSort}
              allSelected={allSelected}
              onSelectAll={onSelectAll}
              onRefresh={onRefresh}
              showColumnOptions={showColumnOptions}
            />
          )}
          {showFilters && (
            <RecordsFilterRow
              columns={columns}
              filters={filters}
              onFilterChange={onFilterChange}
              onApplyFilters={onApplyFilters}
              onClearFilters={onClearFilters}
              users={users}
              procesos={procesos}
              positions={positions}
            />
          )}
        </thead>
        <tbody>
          {loading ? (
            <CmSkeleton rows={25} cols={columns.length} />
          ) : (
            rows.map(row => (
              <RecordsRow
                key={row.id}
                row={row}
                columns={columns}
                selected={selectedIds.includes(row.id)}
                onSelect={onSelect}
                editingCell={editingCell}
                savingCell={savingCell}
                onStartEdit={onStartEdit}
                onCancelEdit={onCancelEdit}
                onSaveEdit={onSaveEdit}
                formato={formato}
                format_category={format_category}
                estados={estados}
                users={users}
                procesos={procesos}
                positions={positions}
                domain={domain}
                configuration_format={configuration_format}
                onSendEmails={onSendEmails}
                onViewConfirmations={onViewConfirmations}
                onRefresh={onRefresh}
                custom_view_id={custom_view_id}
                froalaConfig={froalaConfig}
              />
            ))
          )}
        </tbody>
      </table>

      {!loading && rows.length === 0 && (
        hasActiveFilters ? (
          <div className="cm-empty-state">
            <i className="fas fa-search cm-empty-state__icon" />
            <p className="cm-empty-state__title">No se encontraron resultados</p>
            <p className="cm-empty-state__subtitle">Intenta ajustar los filtros o criterios de búsqueda</p>
          </div>
        ) : (
          <div className="cm-empty-state">
            <i className="fas fa-folder-open cm-empty-state__icon" />
            <p className="cm-empty-state__title">No se ha creado ningún registro</p>
            <p className="cm-empty-state__subtitle">Comienza agregando el primer registro a este formato</p>
            {estados.create && (
              <button
                className="cm-btn cm-btn--primary"
                style={{ marginTop: 16 }}
                onClick={() => navigateToCreate(formato, 0)}
              >
                <i className="fas fa-plus" /> Crear primer registro
              </button>
            )}
          </div>
        )
      )}
    </div>
  );
}
